import { Box, Typography } from "@mui/material";

export interface NavbarStatusItemProps {
	label: string;
	value: string | number;
	highlight?: boolean;
	warning?: boolean;
}

/**
 * Individual status item displayed in the navbar status bar.
 * Shows a label on top and a value below.
 *
 * @param label - Small text label (e.g., "Last Gap", "Speed")
 * @param value - The value to display (e.g., "0.00", "125")
 * @param highlight - Makes text brighter
 * @param warning - Enables pulsing red background animation
 */
export const NavbarStatusItem = ({
	label,
	value,
	highlight = false,
	warning = false,
}: NavbarStatusItemProps) => (
	<Box
		sx={{
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			px: 1.5,
			py: 0.5,
			minWidth: 70,
			borderRadius: 1,
			backgroundColor: warning ? "error.main" : "transparent",
			animation: warning ? "pulseBg 1.5s ease-in-out infinite" : "none",
			"@keyframes pulseBg": {
				"0%, 100%": {
					backgroundColor: "#d32f2f", // error.main
				},
				"50%": {
					backgroundColor: "#7a1a1a", // darker red
				},
			},
		}}
	>
		<Typography
			sx={{
				color: highlight || warning ? "white" : "rgba(255,255,255,0.7)",
				fontSize: "10px",
				textTransform: "uppercase",
				letterSpacing: "0.3px",
				fontWeight: 500,
				lineHeight: 1.2,
			}}
		>
			{label}
		</Typography>
		<Typography
			sx={{
				color: "white",
				fontSize: "14px",
				fontWeight: 600,
				lineHeight: 1.2,
			}}
		>
			{value}
		</Typography>
	</Box>
);
